export default "__VITE_ASSET__a7cd998d__"